export const separator = ':' as const;
export const domain = 'instructions' as const;
export const target = 'model' as const;
export const delimiter = `${separator}etag${separator}` as const;

export type Separator = typeof separator;
export type Domain = typeof domain;
export type Target = typeof target;
export type Delimiter = typeof delimiter;
export type Etag = string;
export type Pathname = string;
export type Key = `${Domain}${Separator}${Target}${Separator}${Pathname}${Delimiter}${Etag}`;

export interface ModelData {
  key: Key;
  data: ArrayBuffer;
}
